import React, { useEffect, useState, useRef } from 'react'
import MainLayout from '../../components/Layout/Layout';
import LandingPageHeader from '../../components/Header/LandingPageHeader';
import { Col, message, Row } from 'antd';
import { LoadingSpinner, Button, CardV2, Slot, Modal, Icon } from 'pepsico-ds'
import { kpiData } from "../../mocks/KpiOverview";
import KpiCard from '../../components/Cards/KpiCard';
import MultiSelectDropdown from '../../components/Dropdown/MultiSelectDropdown';
// import { userData } from '../../mocks/userJson';
import { getCategoriesLevel1, getBusinessUnitsBySector, getCategoriesBySectorAndBusinessUnit, getSectors, getRoles, getYears, getCategoriesLevel2 } from './KpiUtils';
import SingleSelectDropdown from '../../components/Dropdown/SingleSelectDropdown';
// import { spendCardData } from '../../mocks/landingPageData';
import { FetchLandingPageAction, FetchUserInfoV2LandingPageAction, FetchMaxDateAction, FetchSpendCardDataAction, FetchContractfMainAction, FetchMarketIntelInhouseMainAction, FetchSustainabilityMainAction, FetchBlankCategoriesAction, FetchArchletMainAction, FetchTileKpiOverviewAction, FetchR2PMainAction } from '../../redux/action/LandingPageAction';
import { useDispatch, useSelector } from 'react-redux';
import { FetchSupplierPerfMainAction } from '../../redux/action/LandingPageAction'
import { appNames } from '../../constants/appNames'
import { formatIntoDropdownData, formatDate, call7DaysNpsLogic, addCompassCardIfMissingPGCSUser, addPGCSCardIfMissingPGCSUser } from '../../utils/utils';
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { localStoreKeys } from '../../constants/localStoreKeys';
import { allCategoryL0 } from '../../mocks/userJson';
import { SCMdata } from '../../mocks/SCMData';
import { getUserClaims } from '../../utils/auth/unified-auth';
import { useAuth } from '../../utils/auth/useAuth';
import ArchletCard from '../../components/Cards/ArchletCard';
import { FetchCompassMainAction } from '../../redux/action/CommodityBuyPlanAction';
import CompassCard from '../../components/Cards/CompassCard';
import MarketIntelCard from '../../components/Cards/MarketIntelCard';
import { setLoading } from "../../redux/reducer/loaderSlice";
import { store } from "../../redux/store";
import PowerSteeringCard from '../../components/Cards/PowerSteeringCard';
import ForestreetCard from '../../components/Cards/ForestreetCard';
import { FetchPowerSteeringMainAction } from '../../redux/action/SavingsReportingAction';
import { FetchForeStreetMainAction } from '../../redux/action/ForestreetAction';
import { forestreetMockCardData } from '../../mocks/forestreetData';
import { resilincMockCardData } from '../../mocks/resilincData';
import { FetchResilincMainAction } from '../../redux/action/SupplierRislAction';
import { FetchSCMMainAction } from '../../redux/action/SCMAction';
import SCMCard from '../../components/Cards/SCMCard';
import WidgetPanel from '../../components/Button/WidgetPanel';
import reset_icon from "../../../src/assets/reset_icon.svg";
import { ToastContainer, toast, Slide } from "react-toastify";
import { SaveTilesOrderAction, resetToDefaultTilesOrderAction } from '../../redux/action/KpiCardsTileAction';
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import Info from '../../assets/Info.svg'
import CommodityPageHeader from '../../components/Header/CommodityPageHeader';
import Phase2_Banner from '../../assets/Phase2_Banner.svg'
import { useTour } from '../../routes/JoyrideProvide'
import { addCategoryManagementCardIfMissing, addCoManCardIfMissing, addProcurementPerformanceCardIfMissing, dragEndHandle, timerCardLayout } from '../../utils/utils';
import { useLoginEffects } from '../WalkmeTour/UseLoginEffects';
import { urlConstants } from '../../constants/urlConstants';
const defaultYear = window.YEAR

const DEFAULT_DISABLED_L2 = [{ displayText: 'ALL INCLUSIVE', id: 1 }]
function KpiOverview({isShowFooter}) {
    const dispatch = useDispatch()
    const { authState } = useAuth();
    const [roleSelected, setRoleSelected] = useState("")
    const [sectorSelected, setSectorSelected] = useState([])
    const [businessUnitSelected, setBusinessUnitSelected] = useState([])
    const [categoryL0Selected, setCategoryL0Selected] = useState([])
    const [categoryL1Selected, setCategoryL1Selected] = useState([])
    const [categoryL2Selected, setCategoryL2Selected] = useState([])
    const [yearSelected, setYearSelected] = useState("")
    const [sectors, setSectors] = useState([])
    const [businessUnits, setBusinessUnits] = useState([])
    const [categoriesLevel0, setCategoriesLevel0] = useState([])
    const [categoriesLevel1, setCategoriesLevel1] = useState([])
    const [categoriesLevel2, setCategoriesLevel2] = useState([])
    const [years, setYears] = useState([])
    const [allRoles, setAllRoles] = useState([])
    const [userInfoByRole, setUserInfoByRole] = useState({})
    const [l2Enabled, setL2Enabled] = useState(false)
    const [spendCardData, setSpendCardData] = useState({})
    const [comanCardData, setComanCardData] = useState({})
    const [contractCardData, setContractCardData] = useState({})
    const [marketIntelCardData, setMarketIntelCardData] = useState({})
    const [userDataLandingPage, setUserDataLandingPage] = useState({})
    const [sustainabilityCardData, setSustainabilityCardData] = useState({})
    const [archletCardData, setArchletCardData] = useState({})
    const [compassCardData, setCompassCardData] = useState({})
    const [powerSterringCardData, setPowerSterringCardData] = useState({})
    const [foreStreetCardData, setForeStreetCardData] = useState({})
    const [resilincCardData, setResilincCardData] = useState({})
    const [scmCardData, setScmCardData] = useState({})
    const [r2PInsightsCardData, setR2PInsightsCardData] = useState({})
    const [blankCategoriesData, setBlankCategoriesData] = useState([])
    const [loadFlag, setLoadFlag] = useState(true)
    const [saveReset, setSaveReset] = useState('')
    const [landingPageAppliedFilters, setLandingPageAppliedFilters] = useState({ role: [], sectors: [], bus: [], l0s: [], l1s: [], l2s: [],year: [] })
    const [userAccessibleSectors, setUserAccessibleSectors] = useState([])
    const debounceRef = useRef(null);
    let currentController = null;


    const [allowMovement, setAllowMovement] = useState(false);
    const [resetTilesFlag, setResetTilesFlag] = useState(false);
    const [inactiveModal, setInactiveModal] = useState(false);
    const [cardUpdatedList, setCardUpdatedList] = useState([]);
    const [initialKpiCardsList, setInitialKpiCardsList] = useState([])
    const [isTilesOrderSaved, setIsTilesOrderSaved] = useState(false)
    const [disableResetSaveBtn, setDisableResetSaveBtn] = useState(true)

    const userDataV2 = useSelector((state) => state.getUserInfoV2LandingPageReducer);


    const { showToast } = useToast();

    const { startTour } = useTour();
    // let userAccessibleSectorList = [];
  
  useEffect(()=>{
        isShowFooter(allowMovement)
  }, [allowMovement])


  
  useEffect(() => {
    
    // timerCardLayout(allowMovement, inactiveModal, setInactiveModal, setAllowMovement)

    const intervalId = timerCardLayout(
        allowMovement,
        inactiveModal,
        setInactiveModal,
        setAllowMovement
    );

     if(!allowMovement){
        if(resetToDefaultTilesOrderData && resetToDefaultTilesOrderData?.type == "SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION" && saveReset=="ResetToDefault"){
            let transformedCardsValue = transformCards(resetToDefaultTilesOrderData?.tilesOrderDetails)
            setInitialKpiCardsList(transformedCardsValue)
        }
        else if(savedTilesOrderData && savedTilesOrderData?.type == "SUCCESS_SAVE_TILES_ORDER_ACTION" && saveReset=="Save"){
            let transformedCardsValue = transformCards(savedTilesOrderData?.tilesOrderDetails)
            setInitialKpiCardsList(transformedCardsValue)
        }
        else if(initialKpiTilesOrderData && initialKpiTilesOrderData?.type == "SUCCESS_TILE_KPI_OVERVIEW_ACTION"){
            let transformedCardsValue = transformCards(initialKpiTilesOrderData?.tilesOrderDetails)
            setInitialKpiCardsList(transformedCardsValue)
        }
        
    }

    return () => {
        if (intervalId) {
        clearInterval(intervalId);
        }
    };
    
  }, [allowMovement, inactiveModal, cardUpdatedList]);

    
    useEffect(() => {
        async function fetchUserInfo() {
            const user = await getUserClaims();
            if (user) {
                localStorage.setItem('userInfoEmailID', btoa(JSON.stringify(user?.useremail || user?.email)))
                dispatch(FetchLandingPageAction(user));
                dispatch(FetchUserInfoV2LandingPageAction(user));
                dispatch(FetchBlankCategoriesAction(user));
                dispatch(FetchMaxDateAction(user))
                dispatch(setKeyValue({ key: localStoreKeys.oktaUserData, value: user }))
            }
        }
        const pageConfigPromise = fetchUserInfo();
        pageConfigPromise.then(() => {
            setIsLoader(false)
        })
        .catch(error => {
            setIsLoader(false)
        });

            
            
           
    }, []);

    // useEffect(() => {
    //     dispatch(FetchBlankCategoriesAction());
    //     dispatch(FetchMaxDateAction())
    // }, [])

    const isLoading = useSelector((state) => state.loader.isLoading);
    const [isLoader, setIsLoader] = useState(true)
    const userData = useSelector((state) => state.getLandingPageReducer);
    const blankCategories = useSelector((state) => state.getBlankCategoriesReducer);
    const spendAnalyticsCard = useSelector((state) => state.getSpendCardDataReducer);
    const supplierPerfCard = useSelector((state) => state.getSupplierPerfCardDataReducer);
    const contractCard = useSelector((state) => state.getContractCardDataReducer);
    const marketIntelCard = useSelector((state) => state.getMarketIntelInHouseCardDataReducer);
    const sustainabilityCard = useSelector((state) => state.getSustainabilityCardDataReducer);
    const maxDateData = useSelector((state) => state.getMaxDateReducer);
    const archletData = useSelector((state) => state.getArchletCardDataReducer);
    const compassData = useSelector((state) => state.getCompassCardReducer);
    const powerSterringData = useSelector((state) => state.getPowerSteeringMainReducer);
    const foreStreetData = useSelector((state) => state.getForeStreetMainReducer);
    const resilincData = useSelector((state) => state.fetchResilincMainReducer);
    const scmCard = useSelector((state) => state.getSCMMainReducer);
    const r2PInsightsCard = useSelector((state) => state.getR2PInsightsCardDataReducer);

    const initialKpiTilesOrderData = useSelector((state) => state.getTileKpiOverviewReducer);
    
    const savedTilesOrderData = useSelector((state) => state.getSaveTilesOrderReducer);

    const resetToDefaultTilesOrderData = useSelector((state) => state.getResetToDefaultTilesOrderReducer);
  
    useLoginEffects(userData)
    // const scmData = SCMdata

    
    useEffect(() => {
        if (maxDateData && maxDateData.type === "SUCCESS_MAX_DATE_ACTION") {
            const maxDateDataArray = Object.keys(maxDateData)
                .filter(key => key !== "type")
                .map(key => maxDateData[key]);
            dispatch(setKeyValue({ key: localStoreKeys.maxDateForApps, value: maxDateDataArray }))
        }

    }, [maxDateData])

    
    useEffect(() => {
        if (userData && userData.type === "SUCCESS_LANDING_PAGE_ACTION" && loadFlag) {
            setUserDataLandingPage(userData);
            const Roles = getRoles(userData.details)
            const defaultRole = Roles.filter(item => item.displayText === userData.defaultRole)
            setAllRoles(Roles)
            setRoleSelected(defaultRole)
            localStorage.setItem('MainKpiRoleSelected', JSON.stringify(defaultRole))
            const getUserInfoByRole = userData?.details?.filter(item => item.role === defaultRole[0]?.displayText)?.[0]
            setUserInfoByRole(getUserInfoByRole)
            setL2Enabled(getUserInfoByRole?.l2Enabled)

            const feedbackFormUrl = userData?.feedbackFormUrl;
            dispatch(setKeyValue({ key: localStoreKeys.feedbackFormUrl, value: feedbackFormUrl }))
            // dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // // 7 days NPS logic
            // const now = Date.now(); // current timestamp in milliseconds

            // const responseDate = new Date(userData?.mostRecentDate).getTime(); // convert to timestamp in ms

            // const diffInMs = Math.abs(now - responseDate); // difference in milliseconds

            // const daysDiff = diffInMs / (1000 * 60 * 60 * 24); // convert ms to days

            // if (daysDiff >= 7) {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // } else {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: true }))
            // }
            // 7 days NPS logic
            call7DaysNpsLogic(dispatch, userData)
            const allYears = getYears(userData.year)
            // setYearSelected(allYears)
            setYears(allYears)
            let yearVal = allYears
            if (defaultYear !== "-") {
                yearVal = formatIntoDropdownData([Number(defaultYear)], allYears)
            }
            localStorage.setItem("yearSelected", yearVal[0]?.displayText);
            setYearSelected(yearVal)

            localStorage.setItem("maxYear", btoa(allYears[0]?.displayText));
            localStorage.setItem("minYear", btoa(allYears[allYears.length - 1]?.displayText));

            // onRoleChange(defaultRole)

            if (getUserInfoByRole?.roleDetail) {
                const sectors = getSectors(getUserInfoByRole?.roleDetail);
                setSectors(sectors)
                setSectorSelected(sectors)
                localStorage.setItem("MainKpiSectorSelected",JSON.stringify(sectors))
                // saveUserAccessibleSectors(sectors)

                let sectorsToInclude = sectors?.map(item => (item.displayText))
                localStorage.setItem("MainKpiAllUserSectors",btoa(JSON.stringify(sectorsToInclude)))
                setUserAccessibleSectors(sectorsToInclude)

                const BUs = getBusinessUnitsBySector(getUserInfoByRole?.roleDetail, sectorsToInclude);
                setBusinessUnits(BUs)
                setBusinessUnitSelected(BUs)
                localStorage.setItem("MainKpiBUSelected", JSON.stringify(BUs))
                let businessUnitsToInclude = BUs?.map(item => (item.displayText))
                const tempCategories = getCategoriesBySectorAndBusinessUnit(getUserInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude)
                // console.log(tempCategories)
                let categoriesToInclude = tempCategories.map(item => (item.displayText))
                const l0dropdown = formatIntoDropdownData(categoriesToInclude, allCategoryL0)
                setCategoriesLevel0(l0dropdown)
                setCategoryL0Selected(l0dropdown)
                localStorage.setItem('MainKpiCategoryL0Selected', JSON.stringify(l0dropdown))
                const tempCategoriesLevel1 = getCategoriesLevel1(getUserInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude)
                setCategoriesLevel1(tempCategoriesLevel1)
                setCategoryL1Selected(tempCategoriesLevel1)
                localStorage.setItem('MainKpiCategoryL1Selected', JSON.stringify(tempCategoriesLevel1))

                let categoriesL1ToInclude = tempCategoriesLevel1.map(item => (item.displayText))
                const tempCategoriesLevel2 = getCategoriesLevel2(getUserInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "");
                setCategoriesLevel2(tempCategoriesLevel2);
                setCategoryL2Selected(tempCategoriesLevel2);
                localStorage.setItem('MainKpiCategoryL2Selected', JSON.stringify(tempCategoriesLevel2))
                

                spendCardApiCallonChange(defaultRole, sectors, BUs, tempCategories, tempCategoriesLevel1, yearVal, sectorsToInclude)
                
                let mainKpiRoleSelectedData = JSON.parse(localStorage.getItem('MainKpiRoleSelected'))
                setLandingPageAppliedFilters({
                    // role: defaultRole,
                    role: mainKpiRoleSelectedData,
                    sectors: sectors,
                    bus: BUs,
                    l0s: l0dropdown,
                    l1s: tempCategoriesLevel1,
                    l2s: tempCategoriesLevel2,
                    l0sSelected: l0dropdown,
                    l1sSelected: tempCategoriesLevel1,
                    l2sSelected: tempCategoriesLevel2,
                    year: yearVal,
                    allSectors: sectors,
                    allYears: allYears
                })
            }
            setLoadFlag(false)
            dispatch(FetchTileKpiOverviewAction({email:JSON.parse(atob(localStorage.getItem('userInfoEmailID')))}));
        }
    }, [userData])

    
    useEffect(() => {
        if (blankCategories && blankCategories.type === "SUCCESS_BLANK_CATEGORY_ACTION") {
            localStorage.setItem("blankCategories", JSON.stringify(blankCategories))
        }
    }, [blankCategories])

    
    useEffect(() => {
        if (spendAnalyticsCard && spendAnalyticsCard.type === "SUCCESS_SPEND_CARD_ACTION") {
            setSpendCardData(spendAnalyticsCard)
        }
        if (supplierPerfCard && supplierPerfCard.type === "SUCCESS_COMAN_CARD_ACTION") {
            setComanCardData(supplierPerfCard)
        }
        if (contractCard && contractCard.type === "SUCCESS_CONTRACT_CARD_ACTION") {
            setContractCardData(contractCard)
        }
        if (marketIntelCard && marketIntelCard.type === "SUCCESS_MI_INHOUSE_CARD_ACTION") {
            setMarketIntelCardData(marketIntelCard)
        }
        if (sustainabilityCard && sustainabilityCard.type === "SUCCESS_SUSTAINABILITY_CARD_ACTION") {
            setSustainabilityCardData(sustainabilityCard)
        }
        if (archletData && archletData.type === "SUCCESS_ARCHLET_CARD_ACTION") {
            setArchletCardData(archletData)
        }
        if (compassData && compassData.type === "SUCCESS_COMPASS_CARD_VIEW_ACTION") {
            setCompassCardData(compassData)
        }
        if (powerSterringData && powerSterringData.type === "SUCCESS_POWERSTEERING_CARD_ACTION") {
            setPowerSterringCardData(powerSterringData)
        }
        if (foreStreetData && foreStreetData.type === "SUCCESS_FORESTREET_CARD_ACTION") {
            setForeStreetCardData(foreStreetData)
        }
        if (resilincData && resilincData.type === "SUCCESS_RESILINC_MAIN_ACTION") {
            setResilincCardData(resilincData)
        }
        if (resilincData && resilincData.type === "SUCCESS_RESILINC_MAIN_ACTION") {
            setResilincCardData(resilincData)
        }
        if (scmCard && scmCard.type === "SUCCESS_SCM_CARD_ACTION") {
            setScmCardData(scmCard)
        }
        if (r2PInsightsCard && r2PInsightsCard.type === "SUCCESS_R2P_INSIGHTS_CARD_ACTION") {
            setR2PInsightsCardData(r2PInsightsCard)
        }

            
        if(resetToDefaultTilesOrderData && resetToDefaultTilesOrderData?.type == "SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION" && saveReset=="ResetToDefault"){              
            let transformedCardsValue = transformCards(resetToDefaultTilesOrderData?.tilesOrderDetails)
            setInitialKpiCardsList(transformedCardsValue)
        }
        else if(savedTilesOrderData && savedTilesOrderData?.type == "SUCCESS_SAVE_TILES_ORDER_ACTION" && saveReset=="Save"){           
            let transformedCardsValue = transformCards(savedTilesOrderData?.tilesOrderDetails)
            setInitialKpiCardsList(transformedCardsValue)
        }
        else if(initialKpiTilesOrderData && initialKpiTilesOrderData?.type == "SUCCESS_TILE_KPI_OVERVIEW_ACTION"){         
            let transformedCardsValue = transformCards(initialKpiTilesOrderData?.tilesOrderDetails)
            setInitialKpiCardsList(transformedCardsValue)
        }
        
        
    }, [initialKpiTilesOrderData,savedTilesOrderData,spendAnalyticsCard, supplierPerfCard, contractCard, marketIntelCard, sustainabilityCard, archletData, 
        compassData, powerSterringData, foreStreetData, resilincData, scmCard, r2PInsightsCard])

    // useEffect(()=>{
    //     console.log(initialKpiTilesOrderData)
    //     if(initialKpiTilesOrderData && initialKpiTilesOrderData?.type == "SUCCESS_TILE_KPI_OVERVIEW_ACTION"){         
    //         let transformedCardsValue = transformCards(initialKpiTilesOrderData?.tilesOrderDetails)
    //         setInitialKpiCardsList(transformedCardsValue)
    //     }
    // }, [initialKpiTilesOrderData]);    

    
    useEffect(()=>{
        
            if(allowMovement || resetTilesFlag){
                    if(resetToDefaultTilesOrderData && resetToDefaultTilesOrderData?.type == "SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION" && saveReset=="ResetToDefault"){                      
                        let transformedCardsValue = transformCards(resetToDefaultTilesOrderData?.tilesOrderDetails)
                        setInitialKpiCardsList(transformedCardsValue)
                    }
                    else if(savedTilesOrderData && savedTilesOrderData?.type == "SUCCESS_SAVE_TILES_ORDER_ACTION" && saveReset=="Save"){ 
                        let transformedCardsValue = transformCards(savedTilesOrderData?.tilesOrderDetails)
                        setInitialKpiCardsList(transformedCardsValue)
                    }
                    else if(initialKpiTilesOrderData && initialKpiTilesOrderData?.type == "SUCCESS_TILE_KPI_OVERVIEW_ACTION"){ 
                        let transformedCardsValue = transformCards(initialKpiTilesOrderData?.tilesOrderDetails)
                        setInitialKpiCardsList(transformedCardsValue)
                    }
            }
            
            setResetTilesFlag(false)
    }, [allowMovement, resetTilesFlag])
    
    useEffect(()=>{
        if(resetToDefaultTilesOrderData && resetToDefaultTilesOrderData?.type == "SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION" ){
                
            let transformedCardsValue = transformCards(resetToDefaultTilesOrderData?.tilesOrderDetails)
            setInitialKpiCardsList(transformedCardsValue)
        }

    },[resetToDefaultTilesOrderData])

    
    // useEffect(()=>{
	// 	console.log("hideTour: ", localStorage.getItem('hideTour'))
	// 	const hideTour = localStorage.getItem('hideTour') === 'true';
	// 	if (userData?.isWalkMeEnabled && !hideTour) {
	// 	startTour();
	// 	}
		
	// },[userData])
    // 
	//  useEffect(() => {
	// 	const shouldAnimate = sessionStorage.getItem("showLoginAnimation");

	// 	if (shouldAnimate !== "true") return;

	// 	const observer = new MutationObserver(() => {
	// 		const element = document.querySelector(".rocket-wrapper");

	// 		if (element) {
	// 		element.classList.add("animate-blue");

	// 		element.addEventListener(
	// 			"animationend",
	// 			() => {
	// 			element.classList.remove("animate-blue");
	// 			},
	// 			{ once: true }
	// 		);
	// 		sessionStorage.removeItem("showLoginAnimation");
	// 		observer.disconnect(); // stop observing
	// 		}
	// 	});

	// 	observer.observe(document.body, {
	// 		childList: true,
	// 		subtree: true,
	// 	});

	// 	return () => observer.disconnect();
	// }, []);

    
    const showWarningMessage = (message) => {
        showToast('warning', message, {
            icon: <Icon alt="" icon="warning_amber" size="medium" />
        });

    }

        
    
    const spendCardApiCallonChange = (currentRoleSelected, sectors, BUs, categoryL0, categoryL1, years, accessibleSectorList) => {
        // console.log("sectors, BUs, categoryL0, categoryL1, years", sectors, BUs, categoryL0, categoryL1, years);
        // let mainKpiRoleSelectedData = JSON.parse(localStorage.getItem('MainKpiRoleSelected'))
        let mainKpisectorSelectedData = JSON.parse(localStorage.getItem('MainKpiSectorSelected'))
        let mainKpibusinessUnitSelectedData = JSON.parse(localStorage.getItem('MainKpiBUSelected'))
        let mainKpicategoryL0SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL0Selected'))
        let mainKpicategoryL1SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL1Selected'))
        let mainKpicategoryL2SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL2Selected'))
        let mainkpicurrentYearSelected = localStorage.getItem('yearSelected')

        // const tempSectors = sectors?.map(item => item.displayText)
        // const tempBUs = BUs?.map(item => item.displayText)
        // const tempCategoryL0 = categoryL0?.map(item => item.displayText)
        // const tempCategoryL1 = categoryL1?.map(item => item.displayText)
        // const tempYear = years && years?.map(item => item.displayText)


        const tempSectors = mainKpisectorSelectedData?.map(item => item.displayText)
        const tempBUs = mainKpibusinessUnitSelectedData?.map(item => item.displayText)
        const tempCategoryL0 = mainKpicategoryL0SelectedData?.map(item => item.displayText)
        const tempCategoryL1 = mainKpicategoryL1SelectedData?.map(item => item.displayText)
        const tempCategoryL2 = mainKpicategoryL2SelectedData?.map(item => item.displayText)
        const tempYear = years && years?.map(item => item.displayText)
        dispatch(setKeyValue({ key: localStoreKeys.accessibleUserSectors, value: accessibleSectorList }))
        // console.log("tempYear", tempYear)
        
        let spendRequest = {
            // "year": tempYear[0],
            "year": mainkpicurrentYearSelected,
            // "year": yearSelected ? yearSelected[0].displayText : tempYear[0],
            "sector": tempSectors,
            "bu": tempBUs,
            "l0": tempCategoryL0,
            "l1": tempCategoryL1,
            "l2": tempCategoryL2,
            "accessibleUserSectors": accessibleSectorList // *** userAccessibleSectorList
        }

        // let forestreetRequest = { ...spendRequest, email: "amit.agarwala.contractor@pepsico.com", role: (currentRoleSelected && currentRoleSelected.length>0) ? currentRoleSelected[0]['displayText'] : userData.defaultRole }
        let forestreetRequest = { ...spendRequest, email: userData.emailId, role: currentRoleSelected ? currentRoleSelected[0]['displayText'] : userData.defaultRole[0]['displayText'] }
        if (years && tempSectors.length > 0 && tempBUs.length > 0 && tempCategoryL0.length > 0) {

            setIsLoader(true)
            // store.dispatch(setLoading(true));
            const supplierPerfPromise = dispatch(FetchSupplierPerfMainAction(spendRequest));
            let apiCalls = [supplierPerfPromise];
            if (tempCategoryL1.length > 0) {
                apiCalls.push(
                    dispatch(FetchSpendCardDataAction(spendRequest)),
                    dispatch(FetchContractfMainAction(spendRequest)),
                    dispatch(FetchMarketIntelInhouseMainAction(spendRequest)),
                    dispatch(FetchSustainabilityMainAction(spendRequest)),
                    dispatch(FetchArchletMainAction(spendRequest)),
                    dispatch(FetchCompassMainAction(spendRequest)),
                    dispatch(FetchPowerSteeringMainAction(spendRequest)),
                    dispatch(FetchForeStreetMainAction(forestreetRequest)),
                    dispatch(FetchResilincMainAction(spendRequest)),
                    dispatch(FetchSCMMainAction(spendRequest)),
                    dispatch(FetchR2PMainAction(spendRequest)),
                )
            }
            Promise.all(apiCalls)
                .then(() => {
                    // store.dispatch(setLoading(false));
                    setIsLoader(false)
                })
                .catch(error => {
                    console.error("Error in API calls: ", error);
                    // store.dispatch(setLoading(false));
                    setIsLoader(false)
                });
        }
    }

    
    const onRoleChange = (val) => {
        
        if (val && val.length>0) {
            
            setRoleSelected(val)
            localStorage.setItem('MainKpiRoleSelected', JSON.stringify(val))
            const getUserInfoByRole = userData?.details?.filter(item => item.role === val[0]?.displayText)?.[0]
            setUserInfoByRole(getUserInfoByRole)
            setL2Enabled(getUserInfoByRole?.l2Enabled)
            if (getUserInfoByRole?.roleDetail) {
                const sectors = getSectors(getUserInfoByRole?.roleDetail);
                setSectors(sectors)
                setSectorSelected(sectors)
                localStorage.setItem("MainKpiSectorSelected",JSON.stringify(sectors))
                let sectorsToInclude = sectors?.map(item => (item.displayText))
                localStorage.setItem("MainKpiAllUserSectors",btoa(JSON.stringify(sectorsToInclude)))
                setUserAccessibleSectors(sectorsToInclude)
                setUserAccessibleSectors(sectorsToInclude)
                const BUs = getBusinessUnitsBySector(getUserInfoByRole?.roleDetail, sectorsToInclude);
                setBusinessUnits(BUs)
                setBusinessUnitSelected(BUs)
                localStorage.setItem("MainKpiBUSelected", JSON.stringify(BUs))
                let businessUnitsToInclude = BUs?.map(item => (item.displayText))
                const tempCategories = getCategoriesBySectorAndBusinessUnit(getUserInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude)
                
                /*********** Commented OLD LOGIC to maintain category selection *********************/
                // let tempCategoriesToInclude = tempCategories.map(item => (item.displayText))
                // const l0dropdown = formatIntoDropdownData(tempCategoriesToInclude, allCategoryL0)
                // setCategoriesLevel0(l0dropdown)
                // const result = l0dropdown.filter(item =>
                //     categoryL0Selected.some(selected => selected.id === item.id)
                // );
                // setCategoryL0Selected(result)
                // if (result.length == 0) {
                //     message.warning("select category L0")
                // }

                // let categoriesToInclude = result?.map(item => (item.displayText))
                // const tempCategoriesLevel1 = getCategoriesLevel1(getUserInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude)
                // let tempCategoriesL1ToInclude = tempCategoriesLevel1.map(item => (item.displayText))
                // const l1dropdown = formatIntoDropdownData(tempCategoriesToInclude, tempCategoriesLevel1)
                // setCategoriesLevel1(tempCategoriesLevel1)
                // const result1 = tempCategoriesLevel1.filter(item =>
                //     categoryL1Selected.some(selected => selected.displayText === item.displayText)
                // );
                // // setCategoryL1Selected(tempCategoriesLevel1)
                // setCategoryL1Selected(result1)
                /************** OLD LOGIC Ends ***********************/

                /********** NEW REVERTED LOGIC For Category Selection *****/
                setCategoriesLevel0(tempCategories)
                setCategoryL0Selected(tempCategories)
                localStorage.setItem('MainKpiCategoryL0Selected', JSON.stringify(tempCategories))
                let categoriesToInclude = tempCategories.map(item => (item.displayText))
                const tempCategoriesLevel1 = getCategoriesLevel1(getUserInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude)
                setCategoriesLevel1(tempCategoriesLevel1)
                setCategoryL1Selected(tempCategoriesLevel1)
                localStorage.setItem('MainKpiCategoryL1Selected', JSON.stringify(tempCategoriesLevel1))
                
                let categoriesL1ToInclude = tempCategoriesLevel1.map(item => (item.displayText))
                const tempCategoriesLevel2 = getCategoriesLevel2(getUserInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "");
                setCategoriesLevel2(tempCategoriesLevel2);
                setCategoryL2Selected(tempCategoriesLevel2);
                localStorage.setItem('MainKpiCategoryL2Selected', JSON.stringify(tempCategoriesLevel2))
                /************* NEW LOGIC Ends *********************/

                

                /*********** Commented OLD LOGIC to maintain category selection *********************/
                // // spendCardApiCallonChange(sectors, BUs, tempCategories, tempCategoriesLevel1, yearSelected)
                // spendCardApiCallonChange(val, sectors, BUs, result, categoryL1Selected, yearSelected, sectorsToInclude)
                // setLandingPageAppliedFilters({
                //     role: val,
                //     sectors: sectors,
                //     bus: BUs,
                //     l0s: l0dropdown,
                //     l1s: tempCategoriesLevel1,
                //     l0sSelected: result,
                //     l1sSelected: categoryL1Selected,
                //     year: yearSelected,
                //     allSectors: userAccessibleSectors,
                //     allYears: years
                // })
                /************** OLD LOGIC Ends ***********************/

                /********** NEW REVERTED LOGIC For Category Selection *****/
                spendCardApiCallonChange(val, sectors, BUs, tempCategories, tempCategoriesLevel1, yearSelected, sectorsToInclude)
                // let mainKpiRoleSelectedData = JSON.parse(localStorage.getItem('MainKpiRoleSelected'))
                // let mainKpisectorSelectedData = JSON.parse(localStorage.getItem('MainKpiSectorSelected'))
                // let mainKpibusinessUnitSelectedData = JSON.parse(localStorage.getItem('MainKpiBUSelected'))
                // let mainKpicategoryL0SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL0Selected'))
                // let mainKpicategoryL1SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL1Selected'))
                let mainkpicurrentYearSelected = localStorage.getItem('yearSelected')
                let selectedYearObject = years.filter(year=>Number(year.displayText)===Number(mainkpicurrentYearSelected)) 
                setLandingPageAppliedFilters({
                    role: val,
                    sectors: sectors,
                    bus: BUs,
                    l0s: tempCategories,
                    l1s: tempCategoriesLevel1,
                    l2s: tempCategoriesLevel2,
                    l0sSelected: tempCategories,
                    l1sSelected: tempCategoriesLevel1,
                    l2sSelected: tempCategoriesLevel2,
                    // year: yearSelected,
                    // year: mainkpicurrentYearSelected,
                    year: selectedYearObject, // [{ id: 1, displayText: mainkpicurrentYearSelected }],
                    allSectors: JSON.parse(atob(localStorage.getItem("MainKpiAllUserSectors"))), // userAccessibleSectors
                    allYears: years
                })
                /************* NEW LOGIC Ends *********************/
            }
        }
    }

    
    const onSectorChange = (val) => {
        let mainKpiRoleSelectedData = JSON.parse(localStorage.getItem('MainKpiRoleSelected'))
        // let mainKpisectorSelectedData = JSON.parse(localStorage.getItem('MainKpiSectorSelected'))
        // let mainKpibusinessUnitSelectedData = JSON.parse(localStorage.getItem('MainKpiBUSelected'))
        let mainKpicategoryL0SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL0Selected'))
        let mainKpicategoryL1SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL1Selected'))
        let mainKpicategoryL2SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL2Selected'))
        let mainkpicurrentYearSelected = localStorage.getItem('yearSelected')
        let selectedYearObject = years.filter(year=>Number(year.displayText)===Number(mainkpicurrentYearSelected)) 
        if (val && val.length > 0) {
            setSectorSelected(val)
            localStorage.setItem("MainKpiSectorSelected",JSON.stringify(val))
            //update business units when sector changes
            let sectorsToInclude = val?.map(item => (item.displayText))
            const BUs = getBusinessUnitsBySector(userInfoByRole?.roleDetail, sectorsToInclude);
            setBusinessUnits(BUs)
            setBusinessUnitSelected(BUs)
            localStorage.setItem("MainKpiBUSelected", JSON.stringify(BUs))
            let businessUnitsToInclude = BUs?.map(item => (item.displayText))
            const tempCategories = getCategoriesBySectorAndBusinessUnit(userInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude)
            // setCategoriesLevel0(tempCategories)
            // setCategoryL0Selected(tempCategories)

            let categoriesToInclude = tempCategories.map(item => (item.displayText))
            const tempCategoriesLevel1 = getCategoriesLevel1(userInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude)
            // setCategoriesLevel1(tempCategoriesLevel1)
            // setCategoryL1Selected(tempCategoriesLevel1)

            // spendCardApiCallonChange(val, BUs, tempCategories, tempCategoriesLevel1, yearSelected)
            spendCardApiCallonChange(roleSelected, val, BUs, categoryL0Selected, categoryL1Selected, yearSelected, JSON.parse(atob(localStorage.getItem("MainKpiAllUserSectors")))) // userAccessibleSectors)
            setLandingPageAppliedFilters({
                // role: roleSelected,
                role: mainKpiRoleSelectedData,
                sectors: val,
                bus: BUs,
                l0s: categoriesLevel0,
                l1s: categoriesLevel1,
                l2s: categoriesLevel2,
                // l0sSelected: categoryL0Selected,
                l0sSelected: mainKpicategoryL0SelectedData,
                // l1sSelected: categoryL1Selected,
                l1sSelected: mainKpicategoryL1SelectedData,
                l2sSelected: mainKpicategoryL2SelectedData,
                // year: yearSelected,
                year: selectedYearObject, // [{ id: 1, displayText: mainkpicurrentYearSelected }],
                allSectors: JSON.parse(atob(localStorage.getItem("MainKpiAllUserSectors"))), // userAccessibleSectors,
                allYears: years
            })
        } else {
            if (val && val.length === 0) {
                setSectorSelected([])
                localStorage.setItem("MainKpiSectorSelected",JSON.stringify([]))
                setBusinessUnitSelected([])
                localStorage.setItem("MainKpiBUSelected", JSON.stringify([]))
                setLandingPageAppliedFilters({ ...landingPageAppliedFilters, sectors: [] })
                // setCategoryL0Selected([])
                // setCategoryL1Selected([])
                message.warning("At least one sector is required")
            }
        }
    }

    
    const onBusinessUnitChange = (val) => {
        let mainKpiRoleSelectedData = JSON.parse(localStorage.getItem('MainKpiRoleSelected'))
        let mainKpisectorSelectedData = JSON.parse(localStorage.getItem('MainKpiSectorSelected'))
        // let mainKpibusinessUnitSelectedData = JSON.parse(localStorage.getItem('MainKpiBUSelected'))
        let mainKpicategoryL0SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL0Selected'))
        let mainKpicategoryL1SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL1Selected'))
        let mainKpicategoryL2SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL2Selected'))
        let mainkpicurrentYearSelected = localStorage.getItem('yearSelected')
        let selectedYearObject = years.filter(year=>Number(year.displayText)===Number(mainkpicurrentYearSelected)) 
        
        if (val && val.length > 0) {
            setBusinessUnitSelected(val)
            localStorage.setItem("MainKpiBUSelected", JSON.stringify(val))
            //update categories when business units changes

            // let sectorsToInclude = sectorSelected?.map(item => (item.displayText))
            let sectorsToInclude = mainKpisectorSelectedData?.map(item => (item.displayText))
            let businessUnitsToInclude = val?.map(item => (item.displayText))
            const tempCategories = getCategoriesBySectorAndBusinessUnit(userInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude)
            // setCategoriesLevel0(tempCategories)
            // setCategoryL0Selected(tempCategories)

            let categoriesToInclude = tempCategories.map(item => (item.displayText))
            const tempCategoriesLevel1 = getCategoriesLevel1(userInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude)
            // setCategoriesLevel1(tempCategoriesLevel1)
            // setCategoryL1Selected(tempCategoriesLevel1)

            // if (debounceRef.current) {
            //     clearTimeout(debounceRef.current);
            // }
            // debounceRef.current = setTimeout(() => {
            //     spendCardApiCallonChange(roleSelected, sectorSelected, val, categoryL0Selected, categoryL1Selected, yearSelected, userAccessibleSectors)
            // }, 700);
            // spendCardApiCallonChange(sectorSelected, val, tempCategories, tempCategoriesLevel1, yearSelected)
            spendCardApiCallonChange(roleSelected, sectorSelected, val, categoryL0Selected, categoryL1Selected, yearSelected, JSON.parse(atob(localStorage.getItem("MainKpiAllUserSectors")))) // userAccessibleSectors)
            // console.log(sectorSelected)
            setLandingPageAppliedFilters({
                // role: roleSelected,
                role: mainKpiRoleSelectedData,
                // sectors: sectorSelected,
                sectors: mainKpisectorSelectedData,
                bus: val,
                l0s: categoriesLevel0,
                l1s: categoriesLevel1,
                l2s: categoriesLevel2,
                // l0sSelected: categoryL0Selected,
                l0sSelected: mainKpicategoryL0SelectedData,
                // l1sSelected: categoryL1Selected,
                l1sSelected: mainKpicategoryL1SelectedData,
                l2sSelected: mainKpicategoryL2SelectedData,
                // year: yearSelected,
                year: selectedYearObject, // [{ id: 1, displayText: mainkpicurrentYearSelected }],
                allSectors: JSON.parse(atob(localStorage.getItem("MainKpiAllUserSectors"))), // userAccessibleSectors,
                allYears: years
            })
        } else {

            if (val && val.length === 0) {
                setBusinessUnitSelected([])
                localStorage.setItem("MainKpiBUSelected", JSON.stringify([]))
                setLandingPageAppliedFilters({ ...landingPageAppliedFilters, bus: [] })
                // setCategoryL0Selected([])
                // setCategoryL1Selected([])
                message.warning("At least one business unit / market is required")
            }
        }
    }

    
    const onCategoryLevel0Change = (val) => {
        let mainKpiRoleSelectedData = JSON.parse(localStorage.getItem('MainKpiRoleSelected'))
        let mainKpisectorSelectedData = JSON.parse(localStorage.getItem('MainKpiSectorSelected'))
        let mainKpibusinessUnitSelectedData = JSON.parse(localStorage.getItem('MainKpiBUSelected'))
        // let mainKpicategoryL0SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL0Selected'))
        // let mainKpicategoryL1SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL1Selected'))
        let mainkpicurrentYearSelected = localStorage.getItem('yearSelected')
        let selectedYearObject = years.filter(year=>Number(year.displayText)===Number(mainkpicurrentYearSelected))
        if (val && val.length > 0) {
           // console.log(val);
            
            setCategoryL0Selected(val)
            localStorage.setItem('MainKpiCategoryL0Selected', JSON.stringify(val))
            // let sectorsToInclude = sectorSelected?.map(item => (item.displayText))
            let sectorsToInclude = mainKpisectorSelectedData?.map(item => (item.displayText))
            let businessUnitsToInclude = mainKpibusinessUnitSelectedData?.map(item => (item.displayText))
            let categoriesToInclude = val?.map(item => (item.displayText))

            const tempCategoriesLevel1 = getCategoriesLevel1(userInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude)

            setCategoriesLevel1(tempCategoriesLevel1)
            setCategoryL1Selected(tempCategoriesLevel1)
            localStorage.setItem('MainKpiCategoryL1Selected', JSON.stringify(tempCategoriesLevel1))

            
            let categoriesL1ToInclude = tempCategoriesLevel1.map(item => (item.displayText))
            const tempCategoriesLevel2 = getCategoriesLevel2(userInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "");
            setCategoriesLevel2(tempCategoriesLevel2);
            setCategoryL2Selected(tempCategoriesLevel2);
            localStorage.setItem('MainKpiCategoryL2Selected', JSON.stringify(tempCategoriesLevel2))

            const userAccessibleSectorsNew = JSON.parse(atob(localStorage.getItem("MainKpiAllUserSectors")))
            if (val.length === 1 && val[0]['displayText'] === 'Co Man') {
                spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, val, [{ displayText: '1', id: 1 }], yearSelected, userAccessibleSectorsNew)
            } else {
                spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, val, tempCategoriesLevel1, yearSelected, userAccessibleSectorsNew)
            }
            setLandingPageAppliedFilters({
                // role: roleSelected,
                role: mainKpiRoleSelectedData,
                // sectors: sectorSelected,
                sectors: mainKpisectorSelectedData,
                // bus: businessUnitSelected,
                bus: mainKpibusinessUnitSelectedData,
                l0s: categoriesLevel0,
                l1s: tempCategoriesLevel1,
                l2s: tempCategoriesLevel2,
                l0sSelected: val,
                l1sSelected: tempCategoriesLevel1,
                l2sSelected: tempCategoriesLevel2,
                // year: yearSelected,
                year: selectedYearObject, //[{ id: 1, displayText: mainkpicurrentYearSelected }],
                allSectors: userAccessibleSectorsNew,
                allYears: years
            })
        } else {
            if (val && val.length === 0) {
                setCategoryL0Selected([])
                localStorage.setItem('MainKpiCategoryL0Selected', JSON.stringify([]))
                setCategoryL1Selected([])
                localStorage.setItem('MainKpiCategoryL1Selected', JSON.stringify([]))
                setCategoryL2Selected([])
                localStorage.setItem('MainKpiCategoryL2Selected', JSON.stringify([]))
                setLandingPageAppliedFilters({ ...landingPageAppliedFilters, l0s: [], l0sSelected: [] })
                message.warning("At least one category L0 is required")
            }
        }
    }

    
    const onCategoryLevel1Change = (val) => {
        let mainKpiRoleSelectedData = JSON.parse(localStorage.getItem('MainKpiRoleSelected'))
        let mainKpisectorSelectedData = JSON.parse(localStorage.getItem('MainKpiSectorSelected'))
        let mainKpibusinessUnitSelectedData = JSON.parse(localStorage.getItem('MainKpiBUSelected'))
        let mainKpicategoryL0SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL0Selected'))
        // let mainKpicategoryL1SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL1Selected'))
        let mainkpicurrentYearSelected = localStorage.getItem('yearSelected')
        let selectedYearObject = years.filter(year=>Number(year.displayText)===Number(mainkpicurrentYearSelected))
        if (val && val.length > 0) {
            setCategoryL1Selected(val)
            localStorage.setItem('MainKpiCategoryL1Selected', JSON.stringify(val))
         
            let sectorsToInclude = mainKpisectorSelectedData?.map(item => (item.displayText))
            let businessUnitsToInclude = mainKpibusinessUnitSelectedData?.map(item => (item.displayText))
            let categoriesToInclude = mainKpicategoryL0SelectedData.map(item => (item.displayText))
            let categoriesL1ToInclude = val.map(item => (item.displayText))
            const tempCategoriesLevel2 = getCategoriesLevel2(userInfoByRole?.roleDetail, categoriesToInclude, categoriesL1ToInclude, sectorsToInclude, businessUnitsToInclude, "");
            setCategoriesLevel2(tempCategoriesLevel2);
            setCategoryL2Selected(tempCategoriesLevel2);
            localStorage.setItem('MainKpiCategoryL2Selected', JSON.stringify(tempCategoriesLevel2))

            const userAccessibleSectorsNew = JSON.parse(atob(localStorage.getItem("MainKpiAllUserSectors")))
            spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, val, yearSelected, userAccessibleSectorsNew)
            setLandingPageAppliedFilters({
                // role: roleSelected,
                role: mainKpiRoleSelectedData,
                // sectors: sectorSelected,
                sectors: mainKpisectorSelectedData,
                // bus: businessUnitSelected,
                bus: mainKpibusinessUnitSelectedData,
                l0s: categoriesLevel0,
                l1s: categoriesLevel1,
                l2s: tempCategoriesLevel2,
                // l0sSelected: categoryL0Selected,
                l0sSelected: mainKpicategoryL0SelectedData,
                l1sSelected: val,
                l2sSelected: tempCategoriesLevel2,
                // year: yearSelected,
                year: selectedYearObject, // [{ id: 1, displayText: mainkpicurrentYearSelected }],
                allSectors: userAccessibleSectorsNew,
                allYears: years
            })
        } else {
            if (val && val.length === 0) {
                setCategoryL1Selected([])
                localStorage.setItem('MainKpiCategoryL1Selected', JSON.stringify([]))
                setCategoryL2Selected([])
                localStorage.setItem('MainKpiCategoryL2Selected', JSON.stringify([]))
                setLandingPageAppliedFilters({ ...landingPageAppliedFilters, l1s: [], l1sSelected: [] })
                message.warning("At least one category L1 is required")
            }
        }
    }
    
    const onCategoryLevel2Change = (val) => {
        
        let mainKpiRoleSelectedData = JSON.parse(localStorage.getItem('MainKpiRoleSelected'))
        let mainKpisectorSelectedData = JSON.parse(localStorage.getItem('MainKpiSectorSelected'))
        let mainKpibusinessUnitSelectedData = JSON.parse(localStorage.getItem('MainKpiBUSelected'))
        let mainKpicategoryL0SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL0Selected'))
        let mainKpicategoryL1SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL1Selected'))
        let mainkpicurrentYearSelected = localStorage.getItem('yearSelected')
        let selectedYearObject = years.filter(year=>Number(year.displayText)===Number(mainkpicurrentYearSelected))

        if (val && val.length > 0) {
            if (mainKpisectorSelectedData.length > 0) {
                if (mainKpibusinessUnitSelectedData.length > 0) {
                    if (mainKpicategoryL0SelectedData.length > 0) {
                        if (mainKpicategoryL1SelectedData.length > 0) {
                            setCategoryL2Selected(val)
                            localStorage.setItem('MainKpiCategoryL2Selected', JSON.stringify(val))
                            const userAccessibleSectorsNew = JSON.parse(atob(localStorage.getItem("MainKpiAllUserSectors")))
                            spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, categoryL1Selected, yearSelected, userAccessibleSectorsNew)
                            setLandingPageAppliedFilters({
                                role: mainKpiRoleSelectedData,
                                sectors: mainKpisectorSelectedData,
                                bus: mainKpibusinessUnitSelectedData,
                                l0s: categoriesLevel0,
                                l1s: categoriesLevel1,
                                l2s: categoriesLevel2,
                                l0sSelected: mainKpicategoryL0SelectedData,
                                l1sSelected: mainKpicategoryL1SelectedData,
                                l2sSelected: val,
                                year: selectedYearObject,
                                allSectors: userAccessibleSectorsNew,
                                allYears: years
                            })
                        } else {
                            message.warning("Please select at least one category 1")
                        }
                    } else {
                        message.warning("Please select at least one category 0")
                    }
                } else {
                    message.warning("Please select at least one business unit / market")
                }
            } else {
                message.warning("Please select at least one sector")
            }
        } else {

            if (val && val.length === 0) {
                setCategoryL2Selected([])
                localStorage.setItem('MainKpiCategoryL2Selected', JSON.stringify([]))
                setLandingPageAppliedFilters({ ...landingPageAppliedFilters, l2s: [], l2sSelected: [] })
                message.warning("At least one category L2 is required")
            }
        }
    }

    
    const onYearChange = (val) => {
        let mainKpiRoleSelectedData = JSON.parse(localStorage.getItem('MainKpiRoleSelected'))
        let mainKpisectorSelectedData = JSON.parse(localStorage.getItem('MainKpiSectorSelected'))
        let mainKpibusinessUnitSelectedData = JSON.parse(localStorage.getItem('MainKpiBUSelected'))
        let mainKpicategoryL0SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL0Selected'))
        let mainKpicategoryL1SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL1Selected'))
        let mainKpicategoryL2SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL2Selected'))
        // let mainkpicurrentYearSelected = localStorage.getItem('yearSelected')
        
        if (val && val.length > 0) {
            setYearSelected(val)
            localStorage.setItem("yearSelected", val[0].displayText);
            
            const userAccessibleSectorsNew = JSON.parse(atob(localStorage.getItem("MainKpiAllUserSectors")))
            spendCardApiCallonChange(roleSelected, sectorSelected, businessUnitSelected, categoryL0Selected, categoryL1Selected, val, userAccessibleSectorsNew)
            setLandingPageAppliedFilters({
                // role: roleSelected,
                role: mainKpiRoleSelectedData,
                // sectors: sectorSelected,
                sectors: mainKpisectorSelectedData,
                // bus: businessUnitSelected,
                bus: mainKpibusinessUnitSelectedData,
                // l0s: categoryL0Selected,
                // l1s: categoryL1Selected,
                l0s: categoriesLevel0,
                l1s: categoriesLevel1,
                l2s: categoriesLevel2,
                // l0sSelected: categoryL0Selected,
                l0sSelected: mainKpicategoryL0SelectedData,
                // l1sSelected: categoryL1Selected,
                l1sSelected: mainKpicategoryL1SelectedData,
                l2sSelected: mainKpicategoryL2SelectedData,
                year: val,
                allSectors: userAccessibleSectorsNew,
                allYears: years
            })
        } else {
            setYearSelected("")
            message.warning("year is not selected")
        }
    }
    
    
    const onFiltersReset = () => {
        let mainKpiRoleSelectedData = JSON.parse(localStorage.getItem('MainKpiRoleSelected'))
        // let mainKpisectorSelectedData = JSON.parse(localStorage.getItem('MainKpiSectorSelected'))
        // let mainKpibusinessUnitSelectedData = JSON.parse(localStorage.getItem('MainKpiBUSelected'))
        // let mainKpicategoryL0SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL0Selected'))
        // let mainKpicategoryL1SelectedData = JSON.parse(localStorage.getItem('MainKpiCategoryL1Selected'))
        // let mainkpicurrentYearSelected = localStorage.getItem('yearSelected')
        // onRoleChange(roleSelected)
        const allYears = getYears(userData.year)
        setYears(allYears)
        let yearVal = allYears
        if (defaultYear !== "-") {
            yearVal = formatIntoDropdownData([Number(defaultYear)], allYears)
        }
        localStorage.setItem("yearSelected", yearVal[0]?.displayText);
        setYearSelected(yearVal)
        onRoleChange(mainKpiRoleSelectedData)
    }

    
    const cancelTileMovement = () => {
        setAllowMovement(false)

        setCardUpdatedList([])
        setResetTilesFlag(true)

        setDisableResetSaveBtn(true)
        showToast('info', "You have exited layout mode. No changes were made to your layout.", {
            icon: <img src={Info} alt='image' style={{ width: '20px', height: '20px' }} />
        });
    }

    
    const resetToDefaultMovement = () => {
        setAllowMovement(false)
        setDisableResetSaveBtn(true)
        setResetTilesFlag(false)
        setSaveReset("ResetToDefault")
        const reqObj = {
            emailId: userData?.emailId,
        };

        dispatch(resetToDefaultTilesOrderAction(reqObj))


        setCardUpdatedList([])
        showToast('success', "Layout has been restored to default.", {
            icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
        });
    }
        
        
        // const resetTileMovement = () => {
        //     // setCurrentSortedAppList(savedSortedAppList);
        //     setCardUpdatedList([])
        //     setDisableResetSaveBtn(true)
        //     setResetTilesFlag(true)
        //     setAllowMovement(true)

        //     showToast('success', "Layout has been reset to default layout. Cancel to exit layout mode.", {
        //         icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
        //     });
        // }

        
        const savedTilesOrder = () => {
            setIsTilesOrderSaved(true)
            setAllowMovement(false)
            setDisableResetSaveBtn(true)
            setResetTilesFlag(false)
            setSaveReset('Save')
            const saveCardsOrder = cardUpdatedList?.map(card => {
                const originalClassName = card?.content?.props?.className;
                const updatedCardVal = originalClassName.replace("card-v2 card-item ", "");
                return { phCardId: updatedCardVal };
              });

            // Append 'sortOrder' property
            let updatedSaveCardsOrder = saveCardsOrder.map((card, index) => ({
                ...card,
                sortOrder: index + 1
            }));
            const isOnlyPGCSSelected = sectors.length == 1 && sectors[0]?.displayText === "PGCS";

            updatedSaveCardsOrder = addCompassCardIfMissingPGCSUser(updatedSaveCardsOrder);
            updatedSaveCardsOrder = addPGCSCardIfMissingPGCSUser(updatedSaveCardsOrder, initialKpiTilesOrderData);
            updatedSaveCardsOrder = addCoManCardIfMissing(updatedSaveCardsOrder);
            updatedSaveCardsOrder = addCategoryManagementCardIfMissing(updatedSaveCardsOrder);
            updatedSaveCardsOrder = addProcurementPerformanceCardIfMissing(updatedSaveCardsOrder);

            updatedSaveCardsOrder = [...updatedSaveCardsOrder].sort((a, b) => a.sortOrder - b.sortOrder);
            
            const tilesUpdatedOrder = {
                emailId: userData?.emailId,
                tilesOrderDetails: [...updatedSaveCardsOrder]  
            };

        
            
            dispatch(SaveTilesOrderAction(tilesUpdatedOrder))

            showToast('success', "Layout Saved", {
                icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            });

            setCardUpdatedList([])

        }
        
        
        const enableTileCustomisation = () => {
            setAllowMovement(true);
        }

        const onCustomViewManagerClick = () => {
            window.open(urlConstants.createPersona, "_blank", "noopener")
        }


        
        // const dragStartHandle = (e) => {
        //     console.log("dragStartHandle", e)
        // }
        
        
        const handleContinue = () => {
            setAllowMovement(true)
            setInactiveModal(false);
            // showToast('success', "You chose to continue editing. Inactivity timer has been reset.", {
            //     icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            // });
        };
        
        const handleExitEditorMode = () => {
            setAllowMovement(false)
            setInactiveModal(false);
            setDisableResetSaveBtn(true)
            showToast('info', "You were inactive for a while and have been exited from edit mode.", {
                icon: <img src={Info} alt='image' style={{ width: '20px', height: '20px' }} />
            });
        };
        
        const checkAndRemoveCoMan = (cardsConfig)=>{
            // Count occurrences of "AMESA" in sector List
            const amesaCount = userAccessibleSectors?.filter(item => item === "AMESA").length;
            
            // Check if "CO MAN" exists in category List
            const coManExists = categoriesLevel0?.some(item => item.displayText === "CO MAN");
            
            // If there's exactly one "AMESA" in sector List AND "CO MAN" exists in category List, return the same List
            if (userAccessibleSectors.length===1 && amesaCount === 1 && coManExists) {
                return cardsConfig;
            } else {
                // Return a new array without the coman-card
                return cardsConfig?.filter(item => item.phCardId !== "coman-card");
            }
        }
        
        const checkAndRemoveCompassIfOnlyPGCSSector = (cardsConfig)=>{
            // Check if "PGCS" is the only sector selected
            
            const isOnlyPGCSSelected = sectors?.length === 1 && sectors[0]?.displayText === "PGCS";
            // If "PGCS" is the only sector selected, return the List without compass-card, else return the original List
            if (isOnlyPGCSSelected) {
                return cardsConfig?.filter(item => item.phCardId !== "compass-card");
            } else {
                return cardsConfig;
            }
        }
    
    const transformCards = (cardsConfig) => {
        if (!Array.isArray(cardsConfig)) return [];
        cardsConfig = cardsConfig.filter(
            (val) =>
              val.phCardId !== "procurement-performance-card" &&
              val.phCardId !== "category-management-card" &&
              val.phCardId !== "procurement-procedure-card" &&
              val.phCardId !== "pgcs-analytics-card"
          );
        if(userAccessibleSectors.length>0 && categoriesLevel0.length>0) {
            let processedCardConfig = checkAndRemoveCoMan(cardsConfig)
            processedCardConfig = checkAndRemoveCompassIfOnlyPGCSSector(processedCardConfig)
            let returnVal =  processedCardConfig?.map(card => {
            const cardId = card["phCardId"];
            
            // Determine which component to use based on card-id
            let componentSlot;
            let dataVar;
            let capabilityName;
        
            if (cardId === "spend-card") {
                componentSlot = <KpiCard data={spendAnalyticsCard} capability={appNames.spend} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />;
                dataVar = "spendCardData";
                capabilityName = "spend";
            } else if (cardId === "compass-card") {
                componentSlot = <CompassCard data={compassCardData} userDataV2={userDataV2} capability={appNames.compass} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />;
                dataVar = "compassCardData";
                capabilityName = "compass";
            } else if (cardId === "market-card") {
                componentSlot = <MarketIntelCard data={marketIntelCardData} capability={appNames.marketIntel} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />;
                dataVar = "marketIntelCardData";
                capabilityName = "marketIntel";
            } else if (cardId === "sustainability-card") {
                componentSlot = <KpiCard data={sustainabilityCardData} capability={appNames.sustainability} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />;
                dataVar = "sustainabilityCardData";
                capabilityName = "sustainability";
            } else if (cardId === "scm-card") {
                componentSlot = <SCMCard data={scmCardData} capability={appNames.shouldCostModelling} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />
                dataVar = "";
                capabilityName = "";
            } else if (cardId === "coman-card") {
                componentSlot = <KpiCard data={comanCardData} capability={appNames.coman} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />
                dataVar = "";
                capabilityName = "";
            } else if (cardId === "resilinc-card") {
                componentSlot = <ForestreetCard data={resilincCardData} capability={appNames.resilinc} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />
                dataVar = "";
                capabilityName = "";
            } else if (cardId === "forestreet-card") {
                componentSlot = <ForestreetCard data={foreStreetCardData} capability={appNames.forestreet} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />
                dataVar = "";
                capabilityName = "";
            } else if (cardId === "archlet-card") {
                componentSlot = <ArchletCard data={archletCardData} capability={appNames.archlet} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />
                dataVar = "";
                capabilityName = "";
            } else if (cardId === "contract-card") {
                componentSlot = <KpiCard data={contractCard} capability={appNames.contract} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />
                dataVar = "";
                capabilityName = "";
            } else if (cardId === "powersteering-card") {
                componentSlot = <PowerSteeringCard data={powerSterringData} capability={appNames.powersteering} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />
                dataVar = "";
                capabilityName = "";
            } else if (cardId === "r2p-insights-card") {
                componentSlot = <KpiCard data={r2PInsightsCard} capability={appNames.r2pInsights} selectedYear={years} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageAppliedFilters} disabled={allowMovement} />
            } else {
                
            }
        
            return {
                cardHeader: {},
                cardBody: {
                isDark: false,
                slot: componentSlot,
                type: 'slot',
                },
                className: `card-v2 card-item ${cardId}`,
            };
            });
            return returnVal
        }
    };
    
    
    if(authState?.isAuthenticated){
        return (
            <>
                <CommodityPageHeader header={"PepsiCo Procurement Hub"}
                        subtext={"One gateway, endless possibilities."}
                        subtext2={"Simplifying procurement - one click at a time."}
                        image={Phase2_Banner}/>
                <Col xs={12} sm={12} md={24} lg={24} xl={24}>
                    <div className="landing_page_process_overview">
                        <div className="landing_page_title"> 360° KPI view and Insights</div>
                        {/* <div className="landing_page_process_overview">
                            <div className="current_datetime" style={{ color: '#013771', fontSize: 12, fontweight: 400 }}>{formatDate()}</div>
                        </div> */}
                    </div>
                </Col>             
                <Row gutter={[20, 20]} style={{marginTop: "10px"}}>
                    <Col flex="1">
                        <SingleSelectDropdown className={"ph-role-dropdown buy-con-dropdown"} placeholder="Views" label="View" childList={allRoles} selectedValue={roleSelected} setSelectedValue={onRoleChange} disabled={allowMovement} />
                    </Col>
                    <Col flex="1">
                        <MultiSelectDropdown placeholder="Sectors" label="Sector" childList={sectors} selectedValue={sectorSelected} setSelectedValue={onSectorChange}  disabled={allowMovement}/>
                    </Col>
                    <Col flex="1">
                        <MultiSelectDropdown placeholder="BUs" label="Business Unit / Market" childList={businessUnits} selectedValue={businessUnitSelected} setSelectedValue={onBusinessUnitChange} disabled={allowMovement} />
                    </Col>
                    <Col flex="1">
                        <MultiSelectDropdown placeholder="Categories L0" label="Category L0" childList={categoriesLevel0} selectedValue={categoryL0Selected} setSelectedValue={onCategoryLevel0Change} disabled={allowMovement} />
                    </Col>
                    <Col flex="1">
                        <MultiSelectDropdown placeholder="Categories L1" label="Category L1" childList={categoriesLevel1} selectedValue={categoryL1Selected} setSelectedValue={onCategoryLevel1Change} disabled={allowMovement} />
                    </Col>
                    {
                        l2Enabled?
                            <Col flex="1">
                                <MultiSelectDropdown placeholder="Category L2" className='buy-con-dropdown-modal' label="Category L2" childList={categoriesLevel2} selectedValue={categoryL2Selected} setSelectedValue={onCategoryLevel2Change} helperText={"Applicable for selective capabilities"} disabled={allowMovement} />
                            </Col>
                        :
                            <Col flex="1">
                                <SingleSelectDropdown placeholder="Category L2" label="Category L2" childList={DEFAULT_DISABLED_L2} selectedValue={DEFAULT_DISABLED_L2} setSelectedValue={{}} disabled={true} />
                            </Col>

                    }
                    <Col flex="1">
                        <SingleSelectDropdown className={"year-dropdown buy-con-dropdown"} placeholder="Years" label="Year" childList={years} selectedValue={yearSelected} setSelectedValue={onYearChange} disabled={allowMovement} />
                    </Col>
                    {/* <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                        <Button className=""
                                size="small"
                                style={{}}
                                text="Reset Filters"
                                variant="tertiary" onClick={onFiltersReset}></Button>
                    </Col> */}
                </Row>
                <Row justify="space-between">

                <Button
                        size="small"
                        text="Custom View Manager"
                        variant="secondary"
                        onClick={onCustomViewManagerClick}
                        className='custom-view-manager-button'
                        style={{ marginTop: "12px", borderRadius: '4px', cursor:'pointer'}}
                        iconLeading='folder_shared'
                    />

                    <div style={{display: 'flex'}}>
                        <Button
                                size="small"
                                text="Customize Layout"
                                variant="secondary"
                                onClick={enableTileCustomisation}
                                style={{margin:"0px 10px", marginTop:"12px", borderRadius: '4px', cursor:'pointer'}}
                                disabled={allowMovement}
                                iconLeading='create'
                            />


                            <button className="reset-button" onClick={onFiltersReset}  style={allowMovement ? { margin: '12px 0', backgroundColor: '#d0d0d0' } : { margin: '12px 0', }} disabled={allowMovement}>
                                <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                                <span>Reset Filters</span>
                            </button>
                    </div>
                </Row>
                
                {/*
                    <Button 
                            className=""
                            size="small"
                            style={{}}
                            text="Reset Filters"
                            variant="tertiary"
                            iconLeading='undo'
                            onClick={onFiltersReset}>
                    </Button>
                    <br /> 
                */}
                {
                    isLoader ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        : 
                        initialKpiCardsList && initialKpiCardsList?.length > 0 ?
                        <>
                        {/* <div className="kpi-card"> */}
                        <div style={allowMovement ? { height: '84%', overflow: 'hidden !important' } : {}}>
                        <CardV2
                            isDraggable={allowMovement ? true : false}                           
                            cardDataList={initialKpiCardsList}
                            className={allowMovement ? "shuffle-card" : 'static-kpi-card'}
                            maxScrollHeight="90px"
                            sortableCardHeight="277px"
                            // onDragStartHandler={(item, idx) => console.log("onDragStartHandler", item, idx)}
                            onDragEndHandler={(item, newIdx, oldIdx, updatedList) => dragEndHandle(item, newIdx, oldIdx, updatedList, setCardUpdatedList, setDisableResetSaveBtn)}                           
                            state="interactive"
                            style={{}}
                            type="basic"
                            viewport="desktop"
                        />
                        
                        </div>
                        {/* <br/>
                        <br/> */}
                         
                        
{
                                allowMovement && 
                                (
                                    <>
                                        <br/>
                                        <footer className="tile-footer">
                                            <div style={{display:"flex", width:'100%', justifyContent: 'space-between', alignItems: 'center'}}>
                                                    <div>
                                                        <div className='tile-customized-text'>Customize Layout Mode</div>
                                                        <div className='tile-customized-subtext'>Rearrange the dashboard cards to customize your experience</div>
                                                    </div>
                                                    <div style={{display: 'flex'}}>
                                                        <Button
                                                            size="medium"
                                                            text="Cancel"
                                                            variant="tertiary"
                                                            onClick={cancelTileMovement}
                                                            style={{margin:"0px 10px"}}
                                                        />
                                                        <Button
                                                            size="medium"
                                                            text="Reset to Default"
                                                            variant="secondary"
                                                            onClick={resetToDefaultMovement}
                                                            style={{margin:"0px 10px", borderRadius: '4px'}}
                                                        />
                                                        {/* <Button
                                                            size="medium"
                                                            text="Reset Layout"
                                                            variant="secondary"
                                                            onClick={resetTileMovement}
                                                            style={{margin:"0px 10px", borderRadius: '4px'}}
                                                            // disabled={!resetTilesFlag && cardUpdatedList.length == 0}
                                                            // disabled={cardUpdatedList.length == 0}
                                                            disabled={disableResetSaveBtn}
                                                        /> */}
                                                        <Button
                                                            size="medium"
                                                            text="Save Layout"
                                                            variant="primary"
                                                            onClick={savedTilesOrder}
                                                            style={{margin:"0px 10px", borderRadius: '4px'}}
                                                            // disabled={!resetTilesFlag && cardUpdatedList.length == 0}
                                                            // disabled={cardUpdatedList.length == 0}
                                                            disabled={disableResetSaveBtn}
                                                        />
                                                    </div>
                                            </div>
                                        </footer>
                                    </>
                                )
                                
                            }

                            {
                                inactiveModal && 
                                <>
                                    <Modal      
                                      className="inactive-modal"
                                      closeOnOutsideClick={false}
                                      hideCloseButton
                                      onCloseModal={function oFe(){setInactiveModal(false)}}
                                      primaryButtonProps={{
                                        onClick: handleContinue,
                                        size: 'medium',
                                        text: 'Continue',
                                        variant: 'primary'
                                      }}
                                      secondaryButtonProps={{
                                        onClick: handleExitEditorMode,
                                        size: 'medium',
                                        text: 'Exit',
                                        variant: 'tertiary'
                                      }}
                                      showModal={inactiveModal}
                                      showLink={false}
                                        // showSecondaryButton={false}
                                        showTertiaryButton={false}
                                        showAuxiliaryButton={false}
                                      type="S"
                                    >
                                        <div style={{}}>
                                            <div style={{fontSize: '22px', fontWeight: 'bold', marginBottom: '10px', color: '#3A3A3A'}}>Continue Editing ? </div>
                                            <div>You've been inactive for a while from editor mode.</div>
                                        </div>
                                    </Modal>
                                </>
                            }
                        </>
                        : <></>

                }
                {/* </div> */}
            </>
        )
    }
    
}

function KpiOverviewHoc() {
    return <MainLayout Component={KpiOverview} />;
}

// export default KpiOverviewHoc   
export default KpiOverview   
